import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { LogoMark } from '@/components/LogoMark';
import { PublicFooter } from '@/components/PublicFooter';
import { useSite } from '@/lib/useSite';
import { useLocalizedName } from '@/lib/useLocalizedName';

/**
 * غلاف الصفحات العامة.
 *
 * الشروط والخصوصية والتواصل تُفتح بجلسة وبدونها. وداخل التطبيق يحيطها
 * الشريط الجانبي والعلوي؛ وخارجه كانت تُعرض عارية — نصّ يبدأ من أعلى
 * الشاشة ويمتدّ إلى حافتيها، بلا اسم الموقع ولا طريق للعودة.
 *
 * ومن يفتح الرابط من رسالة لا يعرف أين هو، ولا يجد ما يعيده. فالغلاف
 * يعطيه الثلاثة: هوية، وحدوداً للقراءة، وباباً للخروج.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { settings } = useSite();
  const localized = useLocalizedName();
  const appName = localized(settings.appNameEn, settings.appNameAr) || 'Omaraty';

  return (
    <div className="public-shell">
      <header className="public-shell__bar">
        <Link to="/" className="public-shell__brand">
          <LogoMark size={28} />
          <b>{appName}</b>
        </Link>
        <Link to="/" className="button small outline">
          {t('errors.backHome')} <ArrowLeft size={14} aria-hidden />
        </Link>
      </header>

      <main className="public-shell__body">{children}</main>

      <PublicFooter />
    </div>
  );
}
